import React from "react";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { FeatureStrip } from "./components/FeatureStrip";
import { Identification } from "./components/Identification";
import { Method } from "./components/Method";
import { Community } from "./components/Community";
import { Program } from "./components/Program";
import { Results } from "./components/Results";
import { Story } from "./components/Story";
import { Offer } from "./components/Offer";
import { Faq } from "./components/Faq";
import { Closing } from "./components/Closing";
import { Footer } from "./components/Footer";
export function App() {
  return <div className="min-h-screen w-full bg-bg font-sans text-fg" data-id="element-0" data-mp="31cjn9y4cfj0b">
      <Header data-id="element-1" data-mp="2wj8fnurpiy7c" />
      <main data-id="element-2" data-mp="2wip734ny5m5z">
        <Hero data-id="element-3" data-mp="2wi5mthatqlos" />
        <FeatureStrip data-id="element-4" data-mp="28ufmg62gz4gf" />
        <Identification data-id="element-5" data-mp="28tmg367fagyt" />
        <Method data-id="element-6" data-mp="28suumo7jhzm9" />
        <Community data-id="element-7" data-mp="28sl0cofgp6ar" />
        <Program data-id="element-8" data-mp="23vcjcr61v8b3" />
        <Results data-id="element-9" data-mp="23vuokdaowwv5" />
        <Story data-id="element-10" data-mp="23u9tmmkgrbwr" />
        <Offer data-id="element-11" data-mp="23ujha3i1d6za" />
        <Faq data-id="element-12" data-mp="23v2td3l0915e" />
        <Closing data-id="element-13" data-mp="23ti7s3go4sjo" />
      </main>
      <Footer data-id="element-14" data-mp="3ikhaeg9qb525" />
    </div>;
}